import React, { useState } from "react";
import "./Style.scss";
import { Col, Container, Row } from "react-bootstrap";
import traderImage from "../../../Assets/Images/trader_icon.svg";
import investorImage from "../../../Assets/Images/investor_icon.svg";
import onlineTrading from "../../../Assets/Images/online_trading-icon.svg";
import algoTrading from "../../../Assets/Images/algo_trading-icon.svg";
import apiTrading from "../../../Assets/Images/API_Trading-icon.svg";
import PMS from "../../../Assets/Images/PMS.svg";
import MF from "../../../Assets/Images/MF.svg";
import IPO from "../../../Assets/Images/IPO.svg";

const CardContainer = () => {
  const [activeTab, setActiveTab] = useState("tab1");

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  return (
    <>
      <section className="cardSectionContainer">
        <div className="cardSection">
          <div className="tab-container">
            <div className="btn-group container">
              <button
                className={`btn ${activeTab === "tab1" ? "active priBtn" : ""}`}
                onClick={() => handleTabClick("tab1")}
              >
                <div className="button-content">
                  <div className="leftContent contentBtn">
                    <img
                      src={traderImage}
                      alt="Trader"
                      className="button-image"
                    />
                  </div>
                  <div className="leftContent tabInnerContent">
                    <h4>I am a </h4>
                    <h1>Trader</h1>
                    <p>
                      Trades daily in the markets as a professional or happy to
                      meet short-term goals.
                    </p>
                  </div>
                </div>
              </button>
              <button
                className={`btn ${activeTab === "tab2" ? "active secBtn" : ""}`}
                onClick={() => handleTabClick("tab2")}
              >
                <div className="button-content">
                  <div className="rightContent contentBtn">
                    <img
                      src={investorImage}
                      alt="Investor"
                      className="button-image"
                    />
                  </div>
                  <div className="rightContent tabInnerContent">
                    <h4>I am an </h4>
                    <h1>Investor</h1>
                    <p>Long-term investments to meet long-term goals.</p>
                  </div>
                </div>
              </button>
            </div>
            <div className="tab-content">
              {activeTab === "tab1" && (
                <div className="tab-content-inner">
                  <div className="card-container">
                    <Container>
                      <Row className="card-container-rows">
                        <Col className="tabCardInner">
                          <div className="tabCard">
                            <img
                              src={onlineTrading}
                              alt=""
                              className="cardImg"
                            />
                            <h3>ONLINE TRADING</h3>
                            <h6>Speed and Secure Trading Solutions</h6>
                            <p>
                              Web trading platform provides a user fiendly
                              interface with all the charting tools and other
                              trading friendly tools.
                            </p>
                          </div>
                        </Col>
                        <Col className="tabCardInner">
                          <div className="tabCard">
                            <img src={algoTrading} alt="" className="cardImg" />
                            <h3>ALGO TRADING</h3>
                            <h6>Algorithmic Trading Software</h6>
                            <p>
                              Algo Trading platform gives access to
                              algorithms developed by OPG to retail clients.
                            </p>
                          </div>
                        </Col>
                        <Col className="tabCardInner">
                          <div className="tabCard">
                            <img src={apiTrading} alt="" className="cardImg" />
                            <h3>API TRADING</h3>
                            <h6>Trading Markets Using API'S</h6>
                            <p>
                              For seasoned traders using OATS execution engine,
                              integrating with their own strategy for maximum
                              performance.
                            </p>
                          </div>
                        </Col>
                      </Row>
                    </Container>
                  </div>
                </div>
              )}

              {activeTab === "tab2" && (
                <div className="tab-content-inner">
                  <div className="card-container">
                    <Container>
                      <Row className="card-container-rows">
                        <Col className="tabCardInner">
                          <div className="tabCard">
                            <img
                              src={PMS}
                              alt="PMS Illustration"
                              className="cardImg"
                            />
                            <h3>PMS</h3>
                            <h6>Speed & Secure Trading Solutions</h6>
                            <p>
                              OPG Wealth Managers help you manage & maximise
                              your portfolio.
                            </p>
                          </div>
                        </Col>
                        <Col className="tabCardInner">
                          <div className="tabCard">
                            <img
                              src={MF}
                              alt="Mutual Funds Illustration"
                              className="cardImg"
                            />
                            <h3>MUTUAL FUND</h3>
                            <h6>Algorithmic Trading Software</h6>
                            <p>
                              OPG Wealth Managers help you manage & maximise
                              your mutual funds returns.
                            </p>
                          </div>
                        </Col>
                        <Col className="tabCardInner">
                          <div className="tabCard">
                            <img
                              src={IPO}
                              alt="IPO Illustration"
                              className="cardImg"
                            />
                            <h3>IPO</h3>
                            <h6>Trading Markets using API'S</h6>
                            <p>
                              OPG Wealth Managers help you invest in upcoming
                              IPO's for investing in good companies from the
                              start.
                            </p>
                          </div>
                        </Col>
                      </Row>
                    </Container>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default CardContainer;
